import {FC} from 'react';
//mui
import {Box, SxProps, Theme, Typography} from '@mui/material';
//components
import ActionsMenu from '@/shared/components/Table/ActionMenu';
//constants
import {H6} from '@/utils/constants';
//styles
import {tableStatisticsPropsStyle} from './TableStatistics.styles';

interface TableStatisticsProps {
	icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
	title: string | number;
	description: string;
	onClick?: (key: string, action: string) => void;
	actionsData?: string[];
	parentClassName?: SxProps<Theme>;
	iconSx?: SxProps<Theme>;
}

const TableStatistics: FC<TableStatisticsProps> = ({
	icon: Icon,
	title,
	description,
	actionsData,
	onClick,
	parentClassName,
	iconSx,
}) => {
	const handleStatisticClick = (title: string, action: string) => () => onClick && onClick(title, action);

	return (
		<Box sx={{...parentClassName, ...tableStatisticsPropsStyle.statistic, ...iconSx} as SxProps<Theme>}>
			<Icon />

			<Box sx={tableStatisticsPropsStyle.title}>
				<Typography variant={H6}>{title}</Typography>

				<Typography sx={tableStatisticsPropsStyle.description}>{description}</Typography>
			</Box>

			{actionsData && (
				<Box sx={tableStatisticsPropsStyle.dropdown}>
					<ActionsMenu
						content={actionsData.map((action) => (
							<Box
								sx={tableStatisticsPropsStyle.action}
								key={action}
								onClick={handleStatisticClick(description, action)}
							>
								{action}
							</Box>
						))}
						parentClassName={tableStatisticsPropsStyle.dropdownIcon}
						disableRipple
					/>
				</Box>
			)}
		</Box>
	);
};

export default TableStatistics;
